import { Outlet } from "react-router";

import Providers from "@/providers";

export function AppProvidersLayout() {
  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}
